var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "ul",
      {
        staticClass: "nav nav-tabs cf-panel-tab-header cf-panel-lg",
        attrs: { id: "resultTabs" },
      },
      _vm._l(_vm.customViews, function (v) {
        return _c(
          "li",
          {
            class: [{ active: _vm.viewedResults === v.id }],
            attrs: { title: v.title },
          },
          [
            _c(
              "a",
              {
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function ($event) {
                    return _vm.showView(v.id)
                  },
                },
              },
              [_vm._v(_vm._s(v.label || v.title || v.id))]
            ),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "tab-content cf-panel-tab-body cf-panel-lg",
        staticStyle: { "padding-top": "0px" },
      },
      _vm._l(_vm.customViews, function (v) {
        return _c(v.component, {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.viewedResults === v.id,
              expression: "viewedResults === v.id",
            },
          ],
          key: v.id,
          tag: "component",
          attrs: {
            id: v.id,
            active: _vm.viewedResults === v.id,
            store: _vm.storeFor(v.id),
          },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }